import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './artunteruntergrp.list-view.html',
    styleUrls: ['./artunteruntergrp.list-view.scss']
})
export class ArtunteruntergrpListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
